import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/components/ui/use-toast";

export function ContactForm() {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Simulate form submission
      setTimeout(() => {
        setIsSubmitting(false);
        toast({
          title: "Mensagem enviada!",
          description: "Agradecemos seu contato. Responderemos em breve."
        });

        // Clear form
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: ""
        });
      }, 1500);
    } catch (error: any) {
      setIsSubmitting(false);
      toast({
        title: "Erro ao enviar mensagem",
        description: error.message,
        variant: "destructive"
      });
    }
  };

  return (
    <section id="contato" className="py-16 sm:py-20 bg-background text-foreground transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-950 dark:text-white text-center mb-4">
            Fale <span className="text-amber-600 dark:text-krecao-yellow">Conosco</span>
          </h2>
          
          <div className="w-20 h-1 bg-amber-500 dark:bg-krecao-yellow mx-auto mb-10"></div>
          
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label htmlFor="name" className="block text-gray-900 dark:text-gray-100 font-medium mb-2 text-sm sm:text-base">
                  Nome
                </label>
                <Input 
                  id="name" 
                  name="name" 
                  value={formData.name} 
                  onChange={handleChange} 
                  required 
                  placeholder="Seu nome" 
                  className="bg-card border-border text-gray-950 dark:text-white" 
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-900 dark:text-gray-100 font-medium mb-2 text-sm sm:text-base">
                  Email
                </label>
                <Input 
                  id="email" 
                  name="email" 
                  type="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required 
                  placeholder="Seu email" 
                  className="bg-card border-border text-gray-950 dark:text-white" 
                />
              </div>
            </div>
            
            <div>
              <label htmlFor="phone" className="block text-gray-900 dark:text-gray-100 font-medium mb-2 text-sm sm:text-base">
                Telefone
              </label>
              <Input 
                id="phone" 
                name="phone" 
                value={formData.phone} 
                onChange={handleChange} 
                placeholder="Seu telefone" 
                className="bg-card border-border text-gray-950 dark:text-white" 
              />
            </div>
            
            <div>
              <label htmlFor="message" className="block text-gray-900 dark:text-gray-100 font-medium mb-2 text-sm sm:text-base">
                Mensagem
              </label>
              <Textarea 
                id="message" 
                name="message" 
                value={formData.message} 
                onChange={handleChange} 
                required 
                placeholder="Sua mensagem" 
                className="bg-card border-border text-gray-950 dark:text-white min-h-[120px]" 
              />
            </div>
            
            <Button 
              type="submit" 
              disabled={isSubmitting} 
              className="w-full bg-krecao-red hover:bg-krecao-red/90 text-white py-3 text-sm sm:text-base font-bold shadow-md hover:shadow-lg transition-all"
            >
              {isSubmitting ? "Enviando..." : "Enviar Mensagem"}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
